module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/shot/shot-select-chart-menu/shot-select-chart-menu.component.less
// module id = ./src/app/projects/shot/shot-select-chart-menu/shot-select-chart-menu.component.less
// module chunks = main